module.exports = __webpack_public_path__ + "img/IS440686-1259.095e459b.png";